'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import Breadcrumbs from './Breadcrumbs';
import { FileTypes } from 'FileManagerCore/Constants';
import { parseFileExtensionFromSearch } from 'FileManagerCore/utils/parseFileExtensionFromSearch';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Big from 'UIComponents/elements/Big';
import * as SearchTypes from '../enums/SearchTypes';
import getFileSearchType from '../utils/getFileSearchType';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { jsx as _jsx } from "react/jsx-runtime";
class Toolbar extends Component {
  constructor(...args) {
    super(...args);
    this.renderSearchFeedback = ({
      searchProps,
      searchType,
      searchText
    }) => {
      const {
        fileTypeFilterValue,
        isHubLVideoQueryParamValue
      } = searchProps;
      if (searchType === SearchTypes.FILETYPE) {
        if (isHubLVideoQueryParamValue) {
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: `FileManagerDashboard.searchHeader.fileType.${isHubLVideoQueryParamValue.toLowerCase() === 'true' ? 'hubLVideo' : 'nonHubLVideo'}_jsx`,
            elements: {
              Big
            }
          });
        }
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          options: {
            fileType: I18n.text(`FileManagerDashboard.searchHeader.fileType.${fileTypeFilterValue}`)
          },
          message: `FileManagerDashboard.searchHeader.${searchType}_jsx`,
          elements: {
            Big
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "FileManagerDashboard.searchHeader.searchResults_jsx",
        options: {
          searchText
        },
        elements: {
          Big
        }
      });
    };
  }
  render() {
    const {
      searchText,
      onClearSearch,
      fileTypeFilterValue,
      isHubLVideoQueryParamValue
    } = this.props;
    if (!searchText && !fileTypeFilterValue) {
      return /*#__PURE__*/_jsx(UIFlex, {
        className: "m-bottom-2",
        align: "baseline",
        justify: "between",
        children: /*#__PURE__*/_jsx(Breadcrumbs, {})
      });
    }
    const searchProps = Object.assign({}, parseFileExtensionFromSearch(searchText), {
      fileTypeFilterValue,
      isHubLVideoQueryParamValue
    });
    const searchType = getFileSearchType(searchProps);
    return /*#__PURE__*/_jsx(UIAlert, {
      "data-test-id": "search-alert",
      className: "toolbar--search-alert m-top-4 m-bottom-4",
      type: "tip",
      children: /*#__PURE__*/_jsx(UIMediaObject, {
        align: "center",
        itemRight: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          onClick: onClearSearch,
          "data-test-id": "clear-search",
          size: "extra-small",
          className: "m-left-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `FileManagerDashboard.searchHeader.${searchType !== SearchTypes.FILETYPE ? 'clearButton' : 'browseAll'}`
          })
        }),
        children: this.renderSearchFeedback({
          searchProps,
          searchType,
          searchText
        })
      })
    });
  }
}
Toolbar.propTypes = {
  fileTypeFilterValue: PropTypes.oneOf(Object.keys(FileTypes)),
  searchText: PropTypes.string,
  onClearSearch: PropTypes.func.isRequired,
  isHubLVideoQueryParamValue: PropTypes.string
};
export default Toolbar;